export default "__VITE_ASSET__c168e658__"